var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"calculation-button",class:[
            `calculation-button_${_vm.type}`,
            { 'calculation-button_disabled': _vm.disabled, }
        ],on:{"click":function($event){$event.preventDefault();return _setup.calculationButtonClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }